// extracted by mini-css-extract-plugin
export default {"PrecisionCoursingResults":"PrecisionCoursingResults_PrecisionCoursingResults__6tQxE","row":"PrecisionCoursingResults_row__e8Vje"};